import React from "react";

import { useLocation } from "@reach/router";

import { isPageWithoutMobileBottomMenu } from "@/utils/urlUtils";

import CommonFooter from "./commonFooter";
import LandingFooter from "./landingFooter";

const Footer = () => {
  const { pathname } = useLocation();
  const isLanding = isPageWithoutMobileBottomMenu(pathname);

  return (isLanding ? <LandingFooter /> : <CommonFooter />);
};

export default Footer;
